import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
//style
import 'bootstrap/dist/css/bootstrap.css';
import './industry.styl';
//images
import ho from '../../media/industry/ho.png';
import auto from '../../media/industry/auto.png';
import health from '../../media/industry/health.png';
import info from '../../media/industry/info.png';
import outdoor from '../../media/industry/outdoor.png';
import intelli from '../../media/industry/intelli.png';
//text
import { IndustriesText as IndustriesTextEN } from '../../input-text/en/industries_page';
import { IndustriesText as IndustriesTextNL  } from '../../input-text/nl/industries_page';

class Industry extends React.Component {
  constructor(props){
    super(props);
    this.setLocale = this.setLocale.bind(this);

    if(this.props.industry === 'homeandoffice'){
      this.img = ho;
    }
    else if(this.props.industry === 'auto'){
      this.img = auto;
    }
    else if(this.props.industry === 'health'){
      this.img = health;
    }
    else if(this.props.industry === 'info'){
      this.img = info;
    }
    else if(this.props.industry === 'outdoor'){
      this.img = outdoor;
    }
    else if(this.props.industry === 'intelli'){
      this.img = intelli;
    }
  }

  setLocale(locale) {
      this.IndustriesText = null;
      switch (this.props.locale) {
          case 'en':
              this.IndustriesText = IndustriesTextEN;
              break;
          case 'nl':
              this.IndustriesText = IndustriesTextNL;
              break;
          default:
              this.IndustriesText = IndustriesTextEN;
      }
  }

  render(){
    this.setLocale(this.props.locale);

    return(
      <div className='col-sm-6 col-md-4'>
        <div className="industry-big ">
          <Link className='industry-big__link' to={'/industries/'+this.props.industry} >
            <img src={this.img} alt={this.props.industry} />
            <div className={'industry-big__link__overlay ' + this.props.industry}></div>
            <h2>{ this.IndustriesText[this.props.industry].title }</h2>
          </Link>
          <div className='industry-big__quote'>
            <p className="industry-big__quote__text">{ this.IndustriesText[this.props.industry].quote }</p>
            <span className="industry-big__quote__author highlight">– { this.IndustriesText[this.props.industry].author }</span>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

export default connect(mapStateToProps, null)(Industry);



// WEBPACK FOOTER //
// ./src/components/industry/Industry.js